module.exports = __webpack_public_path__ + "img/coupon_bg13.dca9bd4b.png";